import React, { useEffect, useState } from 'react';
import { useConsultants } from '../../hooks/useFinance';
import { INPUT } from './financeText';

// Search administrators by name or email (finance holders only).
export default function ConsultantPicker({ value, onChange }) {
  const [input, setInput] = useState('');
  const [q, setQ] = useState('');
  useEffect(() => {
    const timer = setTimeout(() => setQ(input.trim()), 300);
    return () => clearTimeout(timer);
  }, [input]);
  const { data: consultants = [], isFetching } = useConsultants(
    q,
    !value && q.length >= 2
  );

  if (value) {
    return (
      <div className="mt-1 flex items-center justify-between rounded-md border border-gray-300 px-3 py-1.5 text-sm">
        <span>
          {value.name}{' '}
          <span className="text-xs text-gray-500">{value.email}</span>
        </span>
        <button
          type="button"
          onClick={() => onChange(null)}
          className="text-xs text-claret-500 hover:underline"
        >
          Change
        </button>
      </div>
    );
  }
  return (
    <div className="mt-1 space-y-1">
      <input
        type="search"
        aria-label="Search consultants"
        placeholder="Type a name or email"
        value={input}
        onChange={(e) => setInput(e.target.value)}
        className={`${INPUT} w-full`}
      />
      {q.length >= 2 && (
        <ul className="m-0 max-h-48 list-none overflow-y-auto rounded-md border border-gray-200 p-0">
          {isFetching && (
            <li className="px-3 py-2 text-xs text-gray-500">Searching…</li>
          )}
          {!isFetching && consultants.length === 0 && (
            <li className="px-3 py-2 text-xs text-gray-500">No one matches.</li>
          )}
          {consultants.map((c) => (
            <li key={c.administrator_id}>
              <button
                type="button"
                onClick={() => onChange(c)}
                className="w-full px-3 py-1.5 text-left text-sm hover:bg-gray-50"
              >
                {c.name}{' '}
                <span className="text-xs text-gray-500">{c.email}</span>
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
